import { VkAutologin } from '@skillbox/autolead'

const NotificationTypeToAnalyticName = {
  authorization: 'vk-id-request',
  'auto-lead': 'vk-id-authorization'
}

const onNotification = (res, analytics) => {
  if (!analytics || !NotificationTypeToAnalyticName[res.type]) {
    return
  }

  analytics.push(NotificationTypeToAnalyticName[res.type], res.data)
}

const itsBot = () => {
  return /bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(navigator.userAgent)
}

export const initVkAutoLead = () => {
  // eslint-disable-next-line
  if (typeof vkConnect === 'undefined' || !vkConnect || typeof vkConnectId === 'undefined' || !vkConnectId) {
    return
  }

  // проверка на поисковых ботов
  // взято отсюда: https://stackoverflow.com/a/39704670
  if (itsBot()) {
    return
  }

  if (window.cFormAutocomplete.isNeedAutocomplete) {
    return
  }

  const options = {
    appId: vkConnectId, // eslint-disable-line
    autologinAction: '/landgen/api/v2/vk-connect/exchange-token/',
    redirectPage: `${window.location.origin}/course/auth/`,
    agreementLink: 'https://skillbox.ru/legal-docs/skillbox/file/file_terms_of_use_privacy_policy.pdf',
    onError: window.Sentry?.captureException,
    onNotification: data => onNotification(data, window.$analytics)
  }

  new VkAutologin(options).init()
}
